<div matDialogTitle>{{title}}</div>

<mat-dialog-content>
  <div class="modal-text">{{modalMessage}}</div>
  @for (message of messageList; track message) {
    <ul class="modal-text">
      <li>{{message}}</li>
    </ul>
  }
</mat-dialog-content>
<div class="flex justify-flex-end gap-20">
  <button mat-raised-button [mat-dialog-close]="true" >Close</button>
</div>
